var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssuranceLine1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 396,
    height: 82,
    viewBox: "0 0 396 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-82.9648 81.0208L126.795 81.0208C144.35 81.0208 161.337 74.802 174.743 63.4678L227.916 18.5096C241.322 7.17538 258.309 0.956543 275.864 0.956543L395.1 0.956543",
    stroke: "url(#paint0_linear_72_132)",
    strokeWidth: 1.16035,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_72_132",
    x1: -82.9648,
    y1: 40.9887,
    x2: 395.1,
    y2: 40.9887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssuranceLine1);
export default __webpack_public_path__ + "static/media/assurance-line-1.ecc9e8057422d22ab886dfb3522dbd88.svg";
export { ForwardRef as ReactComponent };